export function getJobs(state) {
  return state.jobs;
}

export function getSelectedJob(state) {
  return state.selectedJob;
}

export function getTasks(state) {
  return state.tasks;
}